// extracted by mini-css-extract-plugin
export default {"badge":"MicrositeNoindexBadge_badge__VMRxj"};